import {
  INVITE_RESENT,
  INVITED_CAREGIVER,
  LOADED_CONNECTIONS,
  LOADED_PENDING_CONNECTIONS,
  REMOVE_CONNECTION,
  REMOVE_PENDING_CONNECTION,
} from 'src/reducers/llu/types';
import { DRAW_MODAL } from 'src/reducers/modal/types';

import { urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { observeStore, store } from 'Utilities/store';

import { REMOVE_CONNECTION_MODAL } from 'Constants/modalTypes';

const handleAddConneciton = (request: any) => {
  const {
    config: { regions },
    user,
  } = store.getState();

  let region = '';

  Object.entries(regions).some(([r, { countries }]) => {
    if (countries.includes(user.country)) {
      region = r;
      return true;
    }

    return false;
  });

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<Invitation>('api:invoke', {
        method: 'POST',
        url: urls.lslApi + 'sharing/llu/invitations',
        data: {
          InvitationType: 'Adult',
          Product: 'LibreLinkUp',
          GatewayType: 'LL-Webviews',
          ReceiverEmail: request.email,
          SenderAccountId: user.id,
          SenderCountry: user.country,
          SenderRegion: region,
          InvitationDetails: {
            ReceiverFirstName: request.firstName,
            ReceiverLastName: request.lastName,
            SenderCulture: user.phoneLanguage,
            SenderFirstName: user.firstName,
            SenderLastNAme: user.lastName,
          },
          // relationShip: '',
        },
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: INVITED_CAREGIVER, invitation: result.data });
          resolve(result);
        } else if ([2, 5].includes(result.status)) {
          resolve(result);
        } else {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: 'ERROR_INVITED_CAREGIVER',
            },
          });
          reject(result);
        }
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_INVITED_CAREGIVER',
          },
        });
        reject(err);
      });
  });
};

const handleLoadConnections = (request: any) => {
  return (request.response = new Promise<LVApiResponse<LLUConnection[]>>((resolve, reject) => {
    mediator
      .request<LLUConnection[]>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'sharing/llu/connections',
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: LOADED_CONNECTIONS, connections: result.data });
          resolve(result);
        } else {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: 'ERROR_LOADED_CONNECTIONS',
            },
          });
          reject(result);
        }
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_LOADED_CONNECTIONS',
          },
        });
        reject(err);
      });
  }));
};

const handleLoadPendingConnections = (request: any) => {
  const { id: senderId } = store.getState().user;

  return (request.response = new Promise<LVApiResponse>((resolve, reject) => {
    mediator
      .request<Invitation[]>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'sharing/llu/invitations/sender/' + senderId,
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: LOADED_PENDING_CONNECTIONS, pending: result.data });
          resolve(result);
        } else {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: 'ERROR_LOADED_PENDING_CONNECTIONS',
            },
          });
          reject(result);
        }
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_LOADED_PENDING_CONNECTIONS',
          },
        });
        reject(err);
      });
  }));
};

const handleRemoveConnection = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request('api:invoke', {
        method: 'DELETE',
        url: urls.lslApi + 'sharing/llu/connections/' + request.connectionId,
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: REMOVE_CONNECTION, connectionId: request.connectionId });
          resolve(result);
        } else {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: 'ERROR_REMOVE_CONNECTION',
            },
          });
          reject(result);
        }
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_REMOVE_CONNECTION',
          },
        });
        reject(err);
      });
  });
};

const handleRemoveInvitation = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request('api:invoke', {
        method: 'DELETE',
        url: urls.lslApi + 'sharing/llu/invitations/' + request.invitationId,
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: REMOVE_PENDING_CONNECTION, invitationId: request.invitationId });
          resolve(result);
        } else {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: 'ERROR_REMOVE_CONNECTION',
            },
          });
          reject(result);
        }
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_REMOVE_CONNECTION',
          },
        });
        reject(err);
      });
  });
};

const handleResendInvite = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<undefined>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'sharing/llu/invitations/' + request.invitationId + '/resend',
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: INVITE_RESENT, inviteId: request.invitationId });
          resolve(result.data);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const handleStopSharingModal = (request: any) => {
  store.dispatch({
    type: DRAW_MODAL,
    modal: REMOVE_CONNECTION_MODAL,
    props: {
      callback: request.callback,
      connectionId: request.connectionId,
      isInvite: request.isInvite,
    },
  });
};

const handleLibreLinkUpRouting = (event: any) => {
  const parts = event.canonicalPath.split('/');

  if (parts.length === 2) {
    Promise.all([handleLoadConnections({}), handleLoadPendingConnections({})]).catch((e) => {
      log.error(e);
    });
  }
};

mediator.subscribe('llu:addConnection', handleAddConneciton);
mediator.subscribe('llu:loadConnections', handleLoadConnections);
mediator.subscribe('llu:loadPendingConnections', handleLoadPendingConnections);
mediator.subscribe('llu:removeConnection', handleRemoveConnection);
mediator.subscribe('llu:removeInvitation', handleRemoveInvitation);
mediator.subscribe('llu:resendInvite', handleResendInvite);
mediator.subscribe('llu:stopSharingModal', handleStopSharingModal);

mediator.subscribe('page:librelinkup', handleLibreLinkUpRouting);

mediator.once('store:created', () => {
  observeStore(
    (state) => state.user.id,
    (userId) => {
      if (userId) {
        Promise.all([handleLoadConnections({}), handleLoadPendingConnections({})]);
      }
    }
  );
});
